import Pricing from '@/api/pricing'

const BG_GREEN_50 = 'bg-green-50'
const planName = {
  PLUS_MONTHLY: 'Plus Monthly',
  PLUS_YEARLY: 'Plus Yearly',
  PRO_MONTHLY: 'Pro Monthly',
  PRO_YEARLY: 'Pro Yearly',
  ESSENTIAL_MONTHLY: 'Essential Monthly',
  ESSENTIAL_YEARLY: 'Essential Yearly',
  EDU_MEDIUM: 'Edu (Medium)',
  EDU_SMALL: 'Edu (Small)',
  TRIAL: 'Trial Plus',
}
const plans = [
  {
    name: 'Free',
    limit: 7,
    price: 0,
    flashDiscount: 0,
    label: 'free',
    type: 'free',
    group: 'free',
    billingCycle: 'free',
    gaEcommerceProductId: 'free',
    color1: 'bg-primary-90',
    color2: 'bg-primary-60',
  },
  // Euro
  {
    name: planName.PLUS_MONTHLY,
    limit: 200,
    price: 32.95,
    label: 'plus',
    type: 'plus-monthly-eu',
    group: 'plus',
    billingCycle: 'monthly',
    currency: 'eur',
    gaEcommerceProductId: 'plus-monthly-eu',
    color1: BG_GREEN_50,
    color2: 'bg-green-10',
  },
  {
    name: planName.PLUS_YEARLY,
    limit: 200,
    price: 131.40,
    label: 'plus',
    type: 'plus-yearly-eu',
    group: 'plus',
    billingCycle: 'yearly',
    perMonth: 11.95,
    currency: 'eur',
    gaEcommerceProductId: 'plus-yearly-eu',
    color1: BG_GREEN_50,
    color2: 'bg-green-10',
  },
  {
    name: planName.PRO_MONTHLY,
    limit: 10000,
    price: 49.95,
    label: 'pro',
    type: 'pro-monthly-eu',
    group: 'pro',
    billingCycle: 'monthly',
    currency: 'eur',
    gaEcommerceProductId: 'pro-monthly-eu',
    color1: 'bg-purple-50',
    color2: 'bg-purple-10',
  },
  {
    name: planName.PRO_YEARLY,
    limit: 10000,
    price: 191.40,
    label: 'pro',
    type: 'pro-yearly-eu',
    group: 'pro',
    billingCycle: 'yearly',
    perMonth: 15.95,
    currency: 'eur',
    gaEcommerceProductId: 'pro-yearly-eu',
    color1: 'bg-purple-50',
    color2: 'bg-purple-10',
  },
  {
    name: planName.ESSENTIAL_MONTHLY,
    limit: 50,
    price: 23.95,
    label: 'essential',
    type: 'essential-monthly-eu',
    group: 'essential',
    billingCycle: 'monthly',
    currency: 'eur',
    gaEcommerceProductId: 'essential-monthly-eu',
    color1: 'bg-yellow-50',
    color2: 'bg-yellow-10',
  },
  {
    name: planName.ESSENTIAL_YEARLY,
    limit: 50,
    price: 95.40,
    label: 'essential',
    type: 'essential-yearly-eu',
    group: 'essential',
    billingCycle: 'yearly',
    perMonth: 7.95,
    currency: 'eur',
    gaEcommerceProductId: 'essential-yearly-eu',
    color1: 'bg-yellow-50',
    color2: 'bg-yellow-10',
  },
  {
    name: 'Edu Small',
    limit: 25,
    price: 4.95,
    label: 'edu small',
    type: 'edu-small-eu',
    group: 'edu',
    billingCycle: 'monthly',
    currency: 'eur',
    gaEcommerceProductId: 'edu-small-eu',
    color1: 'bg-yellow-50',
    color2: 'bg-yellow-10',
  },
  {
    name: 'Edu Medium',
    limit: 50,
    price: 9.95,
    label: 'edu medium',
    type: 'edu-medium-eu',
    group: 'edu',
    billingCycle: 'monthly',
    currency: 'eur',
    gaEcommerceProductId: 'edu-medium-eu',
    color1: BG_GREEN_50,
    color2: 'bg-green-10',
  },
  {
    name: 'Edu Large',
    limit: 200,
    price: 23.95,
    label: 'edu large',
    type: 'edu-large-eu',
    group: 'edu',
    billingCycle: 'monthly',
    currency: 'eur',
    gaEcommerceProductId: 'edu-large-eu',
    color1: 'bg-purple-50',
    color2: 'bg-purple-10',
  },
  {
    name: 'Edu Yearly Small',
    limit: 25,
    price: 35.40,
    label: 'edu small yearly',
    type: 'edu-small-yearly-eu',
    group: 'edu',
    billingCycle: 'yearly',
    perMonth: 2.95,
    currency: 'eur',
    gaEcommerceProductId: 'edu-small-yearly-eu',
    color1: 'bg-yellow-50',
    color2: 'bg-yellow-10',
  },
  {
    name: 'Edu Yearly Medium',
    limit: 50,
    price: 65.40,
    label: 'edu medium yearly',
    type: 'edu-medium-yearly-eu',
    group: 'edu',
    billingCycle: 'yearly',
    perMonth: 5.45,
    currency: 'eur',
    gaEcommerceProductId: 'edu-medium-yearly-eu',
    color1: BG_GREEN_50,
    color2: 'bg-green-10',
  },
  {
    name: 'Edu Yearly Large',
    limit: 200,
    price: 91.80,
    label: 'edu large yearly',
    type: 'edu-large-yearly-eu',
    group: 'edu',
    billingCycle: 'yearly',
    perMonth: 7.65,
    currency: 'eur',
    gaEcommerceProductId: 'edu-large-yearly-eu',
    color1: 'bg-purple-50',
    color2: 'bg-purple-10',
  },
  {
    name: planName.PLUS_MONTHLY,
    limit: 200,
    price: 15,
    flashDiscount: 0,
    label: 'plus',
    oldPlan: 24122019,
    type: 'plus-monthly-24122019',
    group: 'plus',
    billingCycle: 'monthly',
    gaEcommerceProductId: 'plus-monthly-24122019',
    color1: BG_GREEN_50,
    color2: 'bg-green-10',
  },
  {
    name: planName.PLUS_YEARLY,
    limit: 200,
    price: 60,
    flashDiscount: 0,
    label: 'plus',
    oldPlan: 24122019,
    type: 'plus-yearly-24122019',
    group: 'plus',
    billingCycle: 'yearly',
    perMonth: 5.00,
    gaEcommerceProductId: 'plus-yearly-24122019',
    color1: BG_GREEN_50,
    color2: 'bg-green-10',
  },
  {
    name: planName.PRO_MONTHLY,
    limit: 10000,
    price: 36,
    flashDiscount: 0,
    label: 'pro',
    oldPlan: 24122019,
    type: 'pro-monthly-24122019',
    group: 'pro',
    billingCycle: 'monthly',
    gaEcommerceProductId: 'pro-monthly-24122019',
    color1: 'bg-purple-50',
    color2: 'bg-purple-10',
  },
  {
    name: planName.PRO_YEARLY,
    limit: 10000,
    price: 144,
    flashDiscount: 0,
    label: 'pro',
    oldPlan: 24122019,
    type: 'pro-yearly-24122019',
    group: 'pro',
    billingCycle: 'yearly',
    perMonth: 12,
    gaEcommerceProductId: 'pro-yearly-24122019',
    color1: 'bg-purple-50',
    color2: 'bg-purple-10',
  },
  {
    name: planName.PRO_MONTHLY,
    limit: 10000,
    price: 59.95,
    flashDiscount: 0,
    label: 'pro',
    type: 'pro-monthly-10012020',
    group: 'pro',
    billingCycle: 'monthly',
    oldPlan: 10012020,
    gaEcommerceProductId: 'pro-monthly-10012020',
    color1: 'bg-purple-50',
    color2: 'bg-purple-10',
  },
  {
    name: planName.PRO_YEARLY,
    limit: 10000,
    price: 239.40,
    flashDiscount: 0,
    label: 'pro',
    type: 'pro-yearly-10012020',
    group: 'pro',
    billingCycle: 'yearly',
    perMonth: 19.95,
    oldPlan: 10012020,
    gaEcommerceProductId: 'pro-yearly-10012020',
    color1: 'bg-purple-50',
    color2: 'bg-purple-10',
  },

  // new plan 24122019
  {
    name: planName.ESSENTIAL_MONTHLY,
    limit: 50,
    price: 23.95,
    flashDiscount: 9,
    label: 'essential',
    type: 'essential-monthly-07122022',
    group: 'essential',
    billingCycle: 'monthly',
    gaEcommerceProductId: 'essential-monthly-07122022',
    color1: 'bg-yellow-50',
    color2: 'bg-yellow-10',
  },
  {
    name: planName.ESSENTIAL_YEARLY,
    limit: 50,
    price: 95.40,
    flashDiscount: 36,
    label: 'essential',
    type: 'essential-yearly-07122022',
    group: 'essential',
    billingCycle: 'yearly',
    perMonth: 7.95,
    gaEcommerceProductId: 'essential-yearly-07122022',
    color1: 'bg-yellow-50',
    color2: 'bg-yellow-10',
  },

  {
    name: planName.ESSENTIAL_MONTHLY,
    limit: 50,
    price: 23.95,
    flashDiscount: 9,
    label: 'essential',
    type: 'essential-monthly',
    group: 'essential',
    billingCycle: 'monthly',
    gaEcommerceProductId: 'essential-monthly',
    color1: 'bg-yellow-50',
    color2: 'bg-yellow-10',
  },
  {
    name: planName.ESSENTIAL_YEARLY,
    limit: 50,
    price: 95.40,
    flashDiscount: 36,
    label: 'essential',
    type: 'essential-yearly',
    group: 'essential',
    billingCycle: 'yearly',
    perMonth: 7.95,
    gaEcommerceProductId: 'essential-yearly',
    color1: 'bg-yellow-50',
    color2: 'bg-yellow-10',
  },

  {
    name: planName.PLUS_MONTHLY,
    limit: 200,
    price: 32.95,
    flashDiscount: 0,
    label: 'plus',
    type: 'plus-monthly',
    group: 'plus',
    billingCycle: 'monthly',
    gaEcommerceProductId: 'plus-monthly',
    color1: BG_GREEN_50,
    color2: 'bg-green-10',
  },
  {
    name: planName.PLUS_YEARLY,
    limit: 200,
    price: 131.40,
    flashDiscount: 0,
    label: 'plus',
    type: 'plus-yearly',
    group: 'plus',
    billingCycle: 'yearly',
    perMonth: 10.95,
    gaEcommerceProductId: 'plus-yearly',
    color1: BG_GREEN_50,
    color2: 'bg-green-10',
  },
  {
    name: planName.PRO_MONTHLY,
    limit: 10000,
    price: 49.95,
    flashDiscount: 0,
    label: 'pro',
    type: 'pro-monthly',
    group: 'pro',
    billingCycle: 'monthly',
    gaEcommerceProductId: 'pro-monthly',
    color1: 'bg-purple-50',
    color2: 'bg-purple-10',
  },
  {
    name: planName.PRO_YEARLY,
    limit: 10000,
    price: 191.40,
    flashDiscount: 0,
    label: 'pro',
    type: 'pro-yearly',
    group: 'pro',
    billingCycle: 'yearly',
    perMonth: 15.95,
    gaEcommerceProductId: 'pro-yearly',
    color1: 'bg-purple-50',
    color2: 'bg-purple-10',
  },
  {
    name: planName.EDU_SMALL,
    limit: 25,
    price: 4.95,
    flashDiscount: 0,
    label: 'edu (small)',
    type: 'edu-small',
    group: 'edu',
    billingCycle: 'monthly',
    gaEcommerceProductId: 'edu-small',
    color1: 'bg-yellow-50',
    color2: 'bg-yellow-10',
  },
  {
    name: planName.EDU_SMALL,
    limit: 25,
    price: 35.40,
    flashDiscount: 12,
    perMonth: 2.95,
    label: 'edu (small)',
    type: 'edu-small-yearly-07122022',
    group: 'edu',
    billingCycle: 'yearly',
    gaEcommerceProductId: 'edu-small-yearly-07122022',
    color1: 'bg-yellow-50',
    color2: 'bg-yellow-10',
  },
  {
    name: planName.EDU_SMALL,
    limit: 25,
    price: 35.40,
    flashDiscount: 12,
    perMonth: 2.95,
    label: 'edu (small)',
    type: 'edu-small-yearly',
    group: 'edu',
    billingCycle: 'yearly',
    gaEcommerceProductId: 'edu-small-yearly',
    color1: 'bg-yellow-50',
    color2: 'bg-yellow-10',
  },
  {
    name: planName.EDU_MEDIUM,
    limit: 50,
    price: 9.95,
    flashDiscount: 0,
    label: 'edu (medium)',
    type: 'edu-medium',
    group: 'edu',
    billingCycle: 'monthly',
    gaEcommerceProductId: 'edu-medium',
    color1: BG_GREEN_50,
    color2: 'bg-green-10',
  },
  {
    name: planName.EDU_MEDIUM,
    limit: 50,
    price: 65.40,
    flashDiscount: 24,
    perMonth: 5.45,
    label: 'edu (medium)',
    type: 'edu-medium-yearly-07122022',
    group: 'edu',
    billingCycle: 'yearly',
    gaEcommerceProductId: 'edu-medium-yearly-07122022',
    color1: BG_GREEN_50,
    color2: 'bg-green-10',
  },
  {
    name: planName.EDU_MEDIUM,
    limit: 50,
    price: 65.40,
    flashDiscount: 24,
    perMonth: 5.45,
    label: 'edu (medium)',
    type: 'edu-medium-yearly',
    group: 'edu',
    billingCycle: 'yearly',
    gaEcommerceProductId: 'edu-medium-yearly',
    color1: BG_GREEN_50,
    color2: 'bg-green-10',
  },
  {
    name: 'Edu (Large)',
    limit: 200,
    price: 23.95,
    flashDiscount: 0,
    label: 'edu (large)',
    type: 'edu-large',
    group: 'edu',
    billingCycle: 'monthly',
    gaEcommerceProductId: 'edu-large',
    color1: 'bg-purple-50',
    color2: 'bg-purple-10',
  },
  {
    name: 'Edu (Large)',
    limit: 200,
    price: 91.80,
    flashDiscount: 0,
    perMonth: 7.65,
    label: 'edu (large)',
    type: 'edu-large-yearly',
    group: 'edu',
    billingCycle: 'yearly',
    gaEcommerceProductId: 'edu-large-yearly',
    color1: 'bg-purple-50',
    color2: 'bg-purple-10',
  },
  {
    name: 'One-Time (Mini)',
    limit: 15,
    price: 4.95,
    flashDiscount: 2,
    label: 'one-time (mini)',
    type: 'one-time-mini',
    group: 'one-time',
    gaEcommerceProductId: 'one-time-mini',
    color1: 'bg-primary-90',
    color2: 'bg-primary-60',
  },
  {
    name: 'One-Time (Small)',
    limit: 30,
    price: 10.95,
    flashDiscount: 4,
    label: 'one-time (small)',
    type: 'one-time-small',
    group: 'one-time',
    gaEcommerceProductId: 'one-time-small',
    color1: 'bg-yellow-50',
    color2: 'bg-yellow-10',
  },
  {
    name: 'One-Time (Medium)',
    limit: 100,
    price: 26.95,
    flashDiscount: 10,
    label: 'one-time (medium)',
    type: 'one-time-medium',
    group: 'one-time',
    gaEcommerceProductId: 'one-time-medium',
    color1: BG_GREEN_50,
    color2: 'bg-green-10',
  },
  {
    name: 'One-Time (Large)',
    limit: 1000,
    price: 35.95,
    flashDiscount: 0,
    label: 'one-time (large)',
    type: 'one-time-large',
    group: 'one-time',
    gaEcommerceProductId: 'one-time-large',
    color1: 'bg-purple-50',
    color2: 'bg-purple-10',
  },
  {
    name: 'White Label',
    limit: 10000,
    price: 395.00,
    flashDiscount: 0,
    label: 'white label',
    type: 'white-label',
    group: 'white-label',
    billingCycle: 'yearly',
    gaEcommerceProductId: 'white-label',
    color1: 'bg-secondary-50',
    color2: 'bg-secondary-15',
  },
  {
    name: planName.TRIAL,
    limit: 200,
    price: 0,
    flashDiscount: 0,
    label: 'trial',
    type: 'trial-plus-monthly',
    group: 'plus',
    billingCycle: 'monthly',
    gaEcommerceProductId: 'plus-monthly',
    color1: 'bg-green-50',
    color2: 'bg-green-10',
  },
]
function getPlanByType(type, currency = undefined) {
  let plan = null
  if (currency === 'ideal') {
    plan = plans.find((item) => (
      item.type.includes(type)
        && item.currency === 'eur'
    ))
  } else {
    plan = plans.find((item) => (
      item.type === type
    ))
  }
  return plan
}

export default {
  plans,
  getPlanByType,

  _checkPermissionUpgrade(planType, permission, data) {
    if (planType === 'free') return

    if (planType === 'one-time-mini') {
      permission.oneTimeMini = true
    }
    if (planType === 'one-time-small') {
      permission.oneTimeSmall = true
    }
    if (planType === 'one-time-medium') {
      permission.oneTimeMedium = true
      permission.essentialMonthly = true
    }
    if (planType === 'one-time-large') {
      permission.oneTimeLarge = true
      permission.essentialMonthly = true
      permission.plusMonthly = true
    }
    if (planType === 'edu-small-yearly') {
      permission.eduSmallYearly = true
    }
    if (planType === 'edu-medium-yearly') {
      permission.eduSmallYearly = true
      permission.eduMediumYearly = true
    }
    if (planType === 'edu-large-yearly') {
      permission.eduSmallYearly = true
      permission.eduMediumYearly = true
      permission.eduLargeYearly = true
    }
    if (planType === 'essential-monthly') {
      permission.essentialMonthly = true
    }
    if (planType === 'essential-yearly') {
      permission.essentialYearly = true
    }
    if (planType === 'plus-monthly') {
      permission.plusMonthly = true
    }
    if (planType === 'plus-yearly') {
      permission.plusYearly = true
    }
    if (planType === 'pro-monthly') {
      permission.proMonthly = true
    }
    if (planType === 'pro-yearly') {
      permission.proMonthly = true
    }

    if (data.subscription && data.oneTime) {
      permission = {
        essentialMonthly: true,
        essentialYearly: true,
        plusMonthly: true,
        plusYearly: true,
        proMonthly: true,
        proYearly: true,
        eduSmallYearly: true,
        eduMediumYearly: true,
        eduLargeYearly: true,
      }

      if (planType === 'one-time-mini') {
        permission.oneTimeMini = true
      }
      if (planType === 'one-time-small') {
        permission.oneTimeMini = true
        permission.oneTimeSmall = true
      }
      if (planType === 'one-time-medium') {
        permission.oneTimeMini = true
        permission.oneTimeSmall = true
        permission.oneTimeMedium = true
      }
      if (planType === 'one-time-large') {
        permission.oneTimeMini = true
        permission.oneTimeSmall = true
        permission.oneTimeMedium = true
        permission.oneTimeLarge = true
      }
      return
    }

    if (planType === 'one-time-mini') {
      permission.oneTimeMini = true
    }
    if (planType === 'one-time-small') {
      permission.oneTimeMini = true
      permission.oneTimeSmall = true
    }
    if (planType === 'one-time-medium') {
      permission.oneTimeMini = true
      permission.oneTimeSmall = true
      permission.oneTimeMedium = true
    }
    if (planType === 'one-time-large') {
      permission.oneTimeMini = true
      permission.oneTimeSmall = true
      permission.oneTimeMedium = true
      permission.oneTimeLarge = true
    }

    if (data.subscription && !data.oneTime) {
      const subPlan = getPlanByType(data.subscription.type)
      plans.forEach((item) => {
        if (item.price < data.subscription.credit) {
          if (item.type === 'essential-monthly') {
            permission.essentialMonthly = true
          }
          if (item.type === 'essential-yearly') {
            permission.essentialYearly = true
          }
          if (item.type === 'plus-monthly') {
            permission.plusMonthly = true
          }
          if (item.type === 'plus-yearly') {
            permission.plusYearly = true
          }
          if (item.type === 'pro-monthly') {
            permission.proMonthly = true
          }
          if (item.type === 'pro-yearly') {
            permission.proYearly = true
          }
          if (item.type === 'edu-small-yearly') {
            permission.eduSmallYearly = true
          }
          if (item.type === 'edu-medium-yearly') {
            permission.eduMediumYearly = true
          }
          if (item.type === 'edu-large-yearly') {
            permission.eduLargeYearly = true
          }
        }
      })

      if (subPlan.group !== 'edu' && subPlan.billingCycle === 'yearly') {
        permission.eduSmallYearly = true
        permission.eduMediumYearly = true
        permission.eduLargeYearly = true
      }

      if (subPlan.group === 'essential') {
        permission.oneTimeMini = true
        permission.oneTimeSmall = true
      }
      if (subPlan.group === 'plus') {
        permission.oneTimeMini = true
        permission.oneTimeSmall = true
        permission.oneTimeMedium = true
      }
      if (subPlan.group === 'pro') {
        permission.oneTimeMini = true
        permission.oneTimeSmall = true
        permission.oneTimeMedium = true
        permission.oneTimeLarge = true
      }
      if (subPlan.type === 'edu-small') {
        permission.oneTimeMini = true
      }
      if (subPlan.type === 'edu-medium') {
        permission.oneTimeMini = true
        permission.oneTimeSmall = true
      }
      if (subPlan.type === 'edu-large') {
        permission.oneTimeMini = true
        permission.oneTimeSmall = true
        permission.oneTimeMedium = true
      }

      return
    }

    if (!data.subscription && data.oneTime) {
      if (planType === 'one-time-mini') {
        permission.oneTimeMini = true
      }
      if (planType === 'one-time-small') {
        permission.oneTimeMini = true
        permission.oneTimeSmall = true
      }
      if (planType === 'one-time-medium') {
        permission.oneTimeMini = true
        permission.oneTimeSmall = true
        permission.oneTimeMedium = true
      }
      if (planType === 'one-time-large') {
        permission.oneTimeMini = true
        permission.oneTimeSmall = true
        permission.oneTimeMedium = true
        permission.oneTimeLarge = true
      }
      Pricing.plans.forEach((item) => {
        if (item.price < data.oneTime.price) {
          if (item.type === 'essential-monthly') {
            permission.essentialMonthly = true
          }
          if (item.type === 'essential-yearly') {
            permission.essentialYearly = true
          }
          if (item.type === 'plus-monthly') {
            permission.plusMonthly = true
          }
          if (item.type === 'plus-yearly') {
            permission.plusYearly = true
          }
          if (item.type === 'pro-monthly') {
            permission.proMonthly = true
          }
          if (item.type === 'pro-yearly') {
            permission.proYearly = true
          }
          if (item.type === 'edu-small-yearly') {
            permission.eduSmallYearly = true
          }
          if (item.type === 'edu-medium-yearly') {
            permission.eduMediumYearly = true
          }
          if (item.type === 'edu-large-yearly') {
            permission.eduLargeYearly = true
          }
        }
      })
    }
  },

  typePayment: {
    createNewOneTime: 'create-new-one-time',
    createNewSubscrition: 'create-new-subscription',
    updateOneTime: 'update-one-time',
    updateSubscription: 'update-subscription',
    createNewSubscriptionRemoveOneTime: 'create-new-subscription-remove-one-time',
  },
}
